import ZJApp from "../../../../app";

let utils = ZJApp.ZJUtils;
let ZJApi = ZJApp.ZJApis.ZJApi;

const info = {
  service: "CarParkService",
  controller: "tb_car_fee_detail",
};

const methods = [
  "GetItemPagingList",
];

const factory = (Fun) => {
  utils.extend(Fun.prototype, info);
  methods.forEach((path) => {
      Fun.prototype[path] = function(data) {
        return this.post(path, data);
      };
  });
};

const CarParkFeeApi = ZJApi.defineNewApi("CarParkFeeApi", factory);

export default CarParkFeeApi;
